<div class="PGUploadButton {{overlay ? 'PGUploadButton--Overlay' : ''}}">
    <button class="{{ buttonClass != null ? buttonClass : 'btn btn-primary' }}" [disabled]="disabled">
        <i class="{{ buttonIcon != null ? buttonIcon : 'fa-regular fa-upload' }} me-2"></i>
        <span>{{ buttonText != null ? buttonText : 'Upload' }}</span>
        @if (!directory) {
            <input type="file" [disabled]="disabled" #fileInput [accept]="accept" [multiple]="multiple" (change)="checkFiles()"/>
        }
        @if (directory) {
            <input type="file" [disabled]="disabled" #fileInput [attr.webkitdirectory]="directory" [attr.directory]="directory" (change)="checkFiles()"/>
        }
    </button>
</div>